import type { UseFormRegisterReturn } from 'react-hook-form';
import { cn } from '@/lib/utils';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const selectClass = 'block h-11 w-full rounded-xl border border-border bg-surface px-3 text-[15px] text-foreground focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/40';

// Day, month and year as three lists, so nobody has to guess a date format.
export default function DateOfBirthField({ day, month, year, error }: {
  day: UseFormRegisterReturn; month: UseFormRegisterReturn; year: UseFormRegisterReturn; error?: string;
}) {
  const thisYear = new Date().getUTCFullYear();
  const years = Array.from({ length: 121 }, (_, i) => thisYear - i);
  return (
    <fieldset aria-describedby={error ? 'dob-error' : undefined}>
      <legend className="mb-1.5 block text-sm font-medium text-foreground">Date of birth</legend>
      <div className="grid grid-cols-[1fr_1.6fr_1.2fr] gap-2">
        <label className="sr-only" htmlFor="dob-day">Day</label>
        <select id="dob-day" autoComplete="bday-day" defaultValue="" className={cn(selectClass, error && 'border-error')} {...day}>
          <option value="" disabled>Day</option>
          {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
        <label className="sr-only" htmlFor="dob-month">Month</label>
        <select id="dob-month" autoComplete="bday-month" defaultValue="" className={cn(selectClass, error && 'border-error')} {...month}>
          <option value="" disabled>Month</option>
          {MONTHS.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
        </select>
        <label className="sr-only" htmlFor="dob-year">Year</label>
        <select id="dob-year" autoComplete="bday-year" defaultValue="" className={cn(selectClass, error && 'border-error')} {...year}>
          <option value="" disabled>Year</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      {error && <p id="dob-error" className="mt-1.5 text-sm text-error">{error}</p>}
    </fieldset>
  );
}
